var _rect, _rect2, _path, _path2, _g, _path3, _path4, _g2, _g3, _ellipse, _circle, _circle2, _circle3, _circle4, _path5, _path6, _ellipse2, _path7, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCharacterYellow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 69,
    viewBox: "0 0 63 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 61.1691,
    y: 43.1675,
    width: 6.62798,
    height: 21.1462,
    rx: 3.31399,
    transform: "rotate(145.994 61.1691 43.1675)",
    fill: "#FFD36A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6.62798,
    height: 21.1462,
    rx: 3.31399,
    transform: "matrix(0.828978 0.559281 0.559281 -0.828978 1 43.1675)",
    fill: "#FFD36A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3013 52.8072C29.3337 52.8072 29.3596 52.8294 29.392 52.8406V43.6851L20.2253 45.7233C20.2253 45.7233 20.3225 49.566 20.4391 52.8517C20.4715 52.8517 20.5039 52.8183 20.5428 52.8183H29.3013V52.8072Z",
    fill: "#FFD36A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4145 53.8987C20.454 54.3759 20.4869 54.7337 20.5199 54.8881C20.5923 55.4285 20.3091 55.5688 20.0061 55.4565C18.8271 54.8671 17.7732 54.9232 16.8182 55.4565C15.4613 56.3267 15.2308 58.9161 16.3769 59.9617C17.0289 60.6213 17.7271 60.9371 18.4451 61.0002H27.5346C28.7927 60.9511 29.3591 60.1441 29.3921 58.7687V53.8706C29.3921 53.8706 29.3328 53.8917 29.2999 53.8917H20.4145V53.8987Z",
    fill: "#A6E7BC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_681_700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6414 52.3662C29.6414 52.3662 29.5817 52.3428 29.5486 52.3428H20.5846C20.5448 52.3428 20.5183 52.3662 20.4785 52.3662C20.0542 52.4286 19.7161 52.8423 19.7161 53.3574C19.7161 53.9193 20.1006 54.3798 20.5846 54.3798H29.5486C29.5817 54.3798 29.6082 54.3642 29.6414 54.3564C30.0724 54.3018 30.4105 53.8803 30.4105 53.3574C30.4105 52.8345 30.0724 52.4208 29.6414 52.3584V52.3662Z",
    fill: "#A6E7BC"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0474 52.7977C33.0151 52.7977 32.9891 52.8249 32.9568 52.8385V41.6484L42.1234 44.1397C42.1234 44.1397 42.0262 48.8362 41.9096 52.8521C41.8772 52.8521 41.8449 52.8113 41.806 52.8113H33.0474V52.7977Z",
    fill: "#FFD36A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9344 53.8987C41.8949 54.3759 41.8619 54.7337 41.829 54.8881C41.7566 55.4285 42.0398 55.5688 42.3428 55.4565C43.5218 54.8671 44.5756 54.9232 45.5307 55.4565C46.8876 56.3267 47.1181 58.9161 45.972 59.9617C45.3199 60.6213 44.6217 60.9371 43.9038 61.0002H34.8142C33.5562 60.9511 32.9897 60.1441 32.9568 58.7687V53.8706C32.9568 53.8706 33.0161 53.8917 33.049 53.8917H41.9344V53.8987Z",
    fill: "#A6E7BC"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_681_700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7074 52.3662C32.7074 52.3662 32.7671 52.3428 32.8002 52.3428H41.7642C41.804 52.3428 41.8305 52.3662 41.8703 52.3662C42.2946 52.4286 42.6328 52.8423 42.6328 53.3574C42.6328 53.9193 42.2482 54.3798 41.7642 54.3798H32.8002C32.7671 54.3798 32.7406 54.3642 32.7074 54.3564C32.2765 54.3018 31.9383 53.8803 31.9383 53.3574C31.9383 52.8345 32.2765 52.4208 32.7074 52.3584V52.3662Z",
    fill: "#A6E7BC"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_681_700)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5381 7.73417C25.9672 4.98072 29.1093 5.77305 30.3451 8.24465C30.6355 8.82548 31.5648 9.63865 32.9588 8.24465C34.1205 6.7926 39.0576 3.88843 45.1563 11.7297L45.1045 11.646C48.8866 16.5628 50.9274 23.7594 51.7497 34.4213C52.4547 43.5807 52.3071 44.7447 50.1105 47.3275C46.9898 50.9969 43.7012 50.9275 40.4636 47.1206L37.8742 44.0759L35.9217 47.1206C33.5298 50.8487 29.165 51.0663 26.2203 47.6038C24.0736 45.0797 24.0146 45.0797 22.0712 47.6038C19.4761 50.9755 15.3622 50.854 12.3539 47.3168C10.1879 44.77 10.0029 43.4766 10.6011 35.0834C11.4332 23.4092 15.94 12.0927 21.4718 7.78534C21.4938 7.76821 21.5159 7.75115 21.5381 7.73417Z",
    fill: "#FFD36A"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.6652,
    cy: 30.1897,
    rx: 12.9861,
    ry: 12.4768,
    fill: "url(#paint0_radial_681_700)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.7961,
    cy: 24.5582,
    r: 1.98839,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.331339,
    cy: 0.331339,
    r: 0.331339,
    transform: "matrix(-1 0 0 1 28.1216 23.8955)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.0867,
    cy: 24.5582,
    r: 1.98839,
    fill: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.331339,
    cy: 0.331339,
    r: 0.331339,
    transform: "matrix(-1 0 0 1 35.4123 23.8955)",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9337 21.1692C25.7062 21.251 25.5743 21.3469 25.5231 21.4205C25.4443 21.5339 25.2885 21.5618 25.1751 21.483C25.0618 21.4041 25.0338 21.2483 25.1127 21.135C25.2524 20.934 25.5025 20.793 25.7644 20.6987C26.0353 20.6012 26.3584 20.5397 26.6899 20.5231C27.3378 20.4906 28.0973 20.628 28.554 21.1048C28.6495 21.2045 28.6461 21.3628 28.5464 21.4583C28.4466 21.5538 28.2884 21.5504 28.1929 21.4507C27.8857 21.1299 27.3084 20.9927 26.7149 21.0224C26.4258 21.0369 26.1521 21.0906 25.9337 21.1692Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4986 21.1635C33.3184 21.2413 33.2146 21.3316 33.1731 21.4031C33.1039 21.5226 32.9509 21.5633 32.8314 21.494C32.712 21.4248 32.6713 21.2718 32.7405 21.1523C32.8582 20.9494 33.0727 20.8027 33.3003 20.7044C33.5338 20.6036 33.8114 20.5403 34.0956 20.5232C34.6528 20.4897 35.3083 20.6328 35.6985 21.1218C35.7846 21.2297 35.767 21.387 35.6591 21.4731C35.5512 21.5593 35.3938 21.5416 35.3077 21.4337C35.0614 21.125 34.6028 20.9936 34.1256 21.0223C33.8926 21.0363 33.6729 21.0882 33.4986 21.1635Z",
    fill: "black"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.5138,
    cy: 29.5748,
    rx: 1.6306,
    ry: 2.44589,
    fill: "#020304"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_681_700",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 27,
    width: 5,
    height: 3
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1444 29.5748C32.1444 29.2536 32.1022 28.9355 32.0202 28.6388C31.9383 28.342 31.8182 28.0724 31.6668 27.8453C31.5154 27.6182 31.3356 27.438 31.1378 27.3151C30.9399 27.1922 30.7279 27.1289 30.5138 27.1289C30.2996 27.1289 30.0876 27.1922 29.8898 27.3151C29.6919 27.438 29.5122 27.6182 29.3608 27.8453C29.2094 28.0724 29.0892 28.342 29.0073 28.6388C28.9254 28.9355 28.8832 29.2536 28.8832 29.5748L30.5138 29.5748H32.1444Z",
    fill: "#020304"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_681_700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.1395 27.6022L32.1395 26.5852C31.8054 26.8161 31.3735 27.055 30.5138 27.1287C29.8506 27.1582 29.3687 26.9193 28.848 26.6638L28.848 27.6022C28.848 28.8697 32.1444 28.7468 32.1444 27.6022L32.1395 27.6022Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_681_700",
    x: 13.7161,
    y: 46.3428,
    width: 30.6945,
    height: 22.0371,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_681_700"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_681_700",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_681_700",
    x: 25.9383,
    y: 46.3428,
    width: 30.6945,
    height: 22.0371,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_681_700"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_681_700",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_681_700",
    x: 0.306274,
    y: 0,
    width: 61.8199,
    height: 64.0649,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_681_700"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_681_700",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_681_700",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.6652 30.1897) rotate(90) scale(12.4768 12.9861)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2FFB1",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364583,
    stopColor: "#DFF3BE",
    stopOpacity: 0.545833
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharacterYellow);
export default __webpack_public_path__ + "static/media/character_yellow.9954c29cb238439cb8cb8487745873af.svg";
export { ForwardRef as ReactComponent };